import PropTypes from "prop-types";
import { forwardRef } from "react";
import { Icon } from "@iconify/react";
import { Box } from "@mui/material";

// Icons sind hier immer dekorativ (stehen neben sichtbarem Text oder einem
// Button mit eigenem aria-label) – deshalb standardmäßig vor Screenreadern
// versteckt. Bei Bedarf überschreibbar via aria-hidden-Prop.
const Iconify = forwardRef(({ icon, width = 20, sx, ...other }, ref) => (
  <Box
    ref={ref}
    component={Icon}
    icon={icon}
    sx={{ width, height: width, ...sx }}
    aria-hidden="true"
    {...other}
  />
));

Iconify.propTypes = {
  sx: PropTypes.object,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
};

export default Iconify;
